<router-outlet></router-outlet>
<app-assessment-task-browser-modal></app-assessment-task-browser-modal>
<app-assessment-task-form-modal></app-assessment-task-form-modal>
<app-evidence-requirements-host></app-evidence-requirements-host>
